import { AddressFind, DropLocationRemark } from "@m4a3/api-client";

export const getDropPointRemarkReasons = (addressFind: AddressFind): string[] => {
  return [...new Set(addressFind?.dropLocation?.remarks?.map((remark: DropLocationRemark) => remark.reason))];
}

export const addressRemarkDropdownOptions = [
  {
    displayText: 'Please select',
    value: ''
  },
  {
    displayText: 'Outside of geofence',
    value: 'OUTSIDE_GEOFENCE'
  },
  {
    displayText: 'No private property to deliver (apartment)',
    value: 'NO_PRIVATE_PROPERTY_APARTMENT'
  },
  {
    displayText: 'No private property to deliver (duplex)',
    value: 'NO_PRIVATE_PROPERTY_DUPLEX'
  },
  {
    displayText: 'Not enough space to deliver',
    value: 'NOT_ENOUGH_SPACE_TO_DELIVER'
  },
  {
    displayText: 'Tree in the way',
    value: 'TREE_IN_THE_WAY'
  },
  {
    displayText: 'Power Line',
    value: 'POWER_LINE'
  },
  {
    displayText: 'Trampoline in the way',
    value: 'TRAMPOLINE_IN_THE_WAY'
  },
  {
    displayText: 'Shed',
    value: 'SHED'
  },
  {
    displayText: 'Washing line',
    value: 'WASHING_LINE'
  }
];
